import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish } from 'types';

interface DishSatelliteConnection {
  dish_id: number;
  satellite_id: number;
}

export const disconectDishFromSatellite = (
  data: DishSatelliteConnection
): Promise<Dish> => {
  return axios.delete(
    `/api/dishes/${data.dish_id}/connect-satellite/${data.satellite_id}`
  );
};

type UseDisconnectDishFromSatelliteOptions = {
  config?: MutationConfig<typeof disconectDishFromSatellite>;
};

export const useDisconnectDishFromSatellite = ({
  config,
}: UseDisconnectDishFromSatelliteOptions) => {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['satellites']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: disconectDishFromSatellite,
  });
};
